export const heroStats = [
  { label: "在库韩剧", value: "3,860", unit: "部" },
  { label: "本周新更", value: "128", unit: "集" },
  { label: "独播剧场", value: "42", unit: "部" },
  { label: "累计追剧", value: "2.4", unit: "亿次" },
];

export const heroTags = [
  "正在热播",
  "最新更新",
  "高分推荐",
  "全集资源",
  "独播剧",
  "人气榜单",
];

export const genreTabs = [
  "全部",
  "爱情",
  "悬疑",
  "奇幻",
  "复仇",
  "古装",
  "家庭",
  "青春",
  "犯罪",
];

export const guides = [
  {
    id: "guide-airing",
    title: "本周追剧日历：这四部正在热播的韩剧千万别落下",
    category: "追剧指南",
    readTime: "6 分钟",
    excerpt:
      "周一到周日分别有哪些剧更新？把热播档期按星期排开，配合每部的看点提醒，帮你把追剧时间安排得明明白白。",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20flat%20lay%20of%20a%20weekly%20planner%20calendar%20with%20small%20polaroid%20photos%2C%20a%20cup%20of%20coffee%20and%20a%20pen%20on%20a%20warm%20wooden%20desk%2C%20soft%20natural%20morning%20light%2C%20cream%20and%20rose%20tones%2C%20minimal%20editorial%20lifestyle%20photography%2C%20no%20text&width=800&height=500&seq=kd-guide-01&orientation=landscape",
    points: ["工作日更新档期一览", "周末集中补剧清单", "错过的更新如何补齐"],
  },
  {
    id: "guide-score",
    title: "高分韩剧怎么挑？看懂评分、口碑与题材的三条经验",
    category: "选剧方法",
    readTime: "7 分钟",
    excerpt:
      "评分高就一定好看吗？从评分分布、观众口碑和题材匹配三个角度，教你快速判断一部剧到底适不适合自己。",
    cover:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20smartphone%20showing%20a%20rating%20interface%20beside%20a%20notebook%20with%20handwritten%20notes%2C%20warm%20amber%20desk%20lamp%20light%2C%20cream%20and%20gold%20palette%2C%20clean%20editorial%20product%20photography%2C%20shallow%20depth%20of%20field%2C%20no%20text&width=800&height=500&seq=kd-guide-02&orientation=landscape",
    points: ["评分与口碑的区别", "题材标签怎么读", "避开营销型高分的技巧"],
  },
  {
    id: "guide-sageuk",
    title: "从宫廷到市井：入门韩国古装剧的观看顺序建议",
    category: "题材入门",
    readTime: "8 分钟",
    excerpt:
      "古装剧人物关系复杂、时代背景陌生？整理一份从轻到重的观看顺序，先熟悉语境，再进入权谋与家国叙事。",
    cover:
      "https://readdy.ai/api/search-image?query=Traditional%20Korean%20hanok%20courtyard%20with%20paper%20lanterns%20at%20dusk%2C%20layered%20tiled%20roofs%20and%20wooden%20beams%2C%20warm%20gold%20and%20deep%20rose%20palette%2C%20atmospheric%20painterly%20illustration%2C%20no%20text&width=800&height=500&seq=kd-guide-03&orientation=landscape",
    points: ["先看轻喜剧再进权谋", "常用历史称谓速查", "容易被忽略的时代细节"],
  },
];

export const faqs = [
  {
    q: "韩剧TV 主要提供哪些韩剧信息？",
    a: "本站围绕热门韩剧资源需求，整理正在热播的韩剧、最新韩剧更新、高分韩剧推荐与全集资源，另外补充独播剧与人气剧榜单，方便你从不同方向核对和挑选想看的剧。",
  },
  {
    q: "「正在热播」和「最新更新」有什么区别？",
    a: "正在热播指当前处于播出档期内、还在一集一集更新的剧集；最新更新则会同时收录刚完结或刚上线的剧，强调的是一条条更新的时间与集数节奏，两者可以对照查看。",
  },
  {
    q: "高分推荐是按什么标准排序的？",
    a: "高分推荐以观众综合评分为主要依据，并结合题材分类呈现，方便你按喜欢的类型筛选。评分反映的是整体口碑，具体是否合口味，还需要结合题材与剧情简介判断。",
  },
  {
    q: "全集资源板块收录的是哪类剧？",
    a: "全集资源收录已经完结、可以一次性看完的剧集，适合不喜欢一周一集等待的观众。板块内提供题材筛选与关键词检索，帮助你在已有片单里快速定位。",
  },
  {
    q: "独播剧和普通剧集有什么区别？",
    a: "独播剧场是在本站单独整理、其他方向较少覆盖的剧集集合。它们同样按题材与评分归类，只是作为一条更集中的观看线索单独呈现。",
  },
  {
    q: "人气剧榜单是怎么看的？",
    a: "人气榜单按站内累计观看热度排序，反映的是近期观众的关注集中度。它和评分并不总是重合，热度高说明讨论多，评分高代表口碑稳，两者结合着看更准确。",
  },
];

export const footerLinks = [
  { label: "正在热播", href: "#airing" },
  { label: "最新更新", href: "#latest" },
  { label: "高分推荐", href: "#top-rated" },
  { label: "全集资源", href: "#library" },
  { label: "独播剧场", href: "#exclusive" },
  { label: "人气榜单", href: "#ranking" },
];